import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { ShellComponent } from '../../../ui/display/local-shell.component';
@Component({
    selector: 'protection-plans-item',
    templateUrl: 'protection-plans-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UpperCasePipe, ResultComponent, TranslationModule, ActionComponent, ICmsClientModule, ImageModule, ShellComponent]
})
export class ProtectionPlansItemComponent extends ProductAddToBasketComponentDef {
    override product?: Product<IProductDataV3>;

    get currencySymbol(): string | undefined {
        const base = this.app.data.currency.base;

        const currency = this.app.data.currency.list.find(curr => curr.code === base);
        if (currency) {
            return currency.symbol;
        }
        return undefined;
    }
}
